import { useMemo } from 'react';

export let getId = () => {
  let id = Math.floor(Math.random() * new Date().getTime()).toString(36);
  return 'vapor_' + id;
};

export let useId = () => useMemo(() => getId(), []);
